import React from 'react'
import { css, useTheme } from '@emotion/react'
import { Modal } from '../base-ui'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { useRouter } from 'next/router'
import Button from './Button'

function SearchModal({ trigger }) {
    const { push } = useRouter()
    const { t } = useTranslation(['common'])
    const [val, setVal] = useState()
    const [msg, setMsg] = useState()
    const [query, setQuery] = useState('q')
    const [visible, setVisible] = useState(false)
    const theme = useTheme()
    const inputStyle = css`
        width: 100%;
        background-color: transparent;
        outline: none;
        border-bottom: 2px solid #343434;
        padding: 1rem;
        color: #eeeeee;
        font-size: 2rem;
    `
    const mainStyle = css`
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
        button {
            width: 10rem;
        }
    `
    const searchFn = () => {
        if (!val) {
            setMsg('لطفاً یک عبارت تایپ کنید')
            return
        }
        setVisible(false)
        setVal('')
        push(`/search?${query}=${val || ''}`, undefined, {
            shallow: false,
        })
    }

    return (
        <>
            {React.cloneElement(trigger, {
                onClick: () => {
                    setVisible(true)
                },
            })}
            <Modal visible={visible} onClose={() => setVisible(false)}>
                <div css={mainStyle}>
                    <input
                        css={inputStyle}
                        type="search"
                        id="mySearch"
                        name="q"
                        placeholder={t('جستجو کنید', { ns: 'common' }) + '...'}
                        value={val}
                        onChange={(e) => {
                            setVal(e.target.value)
                        }}
                        onKeyDown={(e) => {
                            if (e.code !== 'Enter') return
                            searchFn()
                        }}
                    />
                    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-start', alignSelf: 'flex-start',alignItems: 'center', color: 'white', flexWrap: 'wrap' }}>
                        {t('جستجو در', { ns: 'common' })}
                        <div style={{
                            display: 'inline-flex',
                            backgroundColor: query === 'q' ? theme.colors.primary : 'transparent',
                            border: `1px solid ${theme.colors.primary}`,
                            padding: '2px 5px', borderRadius: '5px',
                            color: theme.colors.white,
                            cursor: 'pointer',
                        }}
                            onClick={() => setQuery('q')}>
                            {t('عنوان', { ns: 'common' })}
                        </div>
                        <div style={{
                            display: 'inline-flex',
                            backgroundColor: query === 'tag' ? theme.colors.primary : 'transparent',
                            border: `1px solid ${theme.colors.primary}`,
                            padding: '2px 5px', borderRadius: '5px',
                            color: theme.colors.white,
                            cursor: 'pointer',
                        }}
                            onClick={() => setQuery('tag')}>
                            {t('برچسب', { ns: 'common' })}
                        </div>
                        <div style={{
                            display: 'inline-flex',
                            backgroundColor: query === 'author' ? theme.colors.primary : 'transparent',
                            border: `1px solid ${theme.colors.primary}`,
                            padding: '2px 5px', borderRadius: '5px',
                            color: theme.colors.white,
                            cursor: 'pointer',
                        }}
                            onClick={() => setQuery('author')}>
                            {t('نویسنده', { ns: 'common' })}
                        </div>
                        <div style={{
                            display: 'inline-flex',
                            backgroundColor: query === 'content' ? theme.colors.primary : 'transparent',
                            border: `1px solid ${theme.colors.primary}`,
                            padding: '2px 5px', borderRadius: '5px',
                            color: theme.colors.white,
                            cursor: 'pointer',
                        }}
                            onClick={() => setQuery('content')}>
                            {t('متن', { ns: 'common' })}
                        </div>
                    </div>
                    <Button
                        onClick={() => {
                            searchFn()
                        }}
                    >
                        {t('جستجو', { ns: 'common' })}
                    </Button>
                    <span style={{ color: 'red' }}>{msg}</span>
                </div>
            </Modal>
        </>
    )
}

export default SearchModal
